import { normalizeWheel } from './normalizeWheel';

export { normalizeWheel };
